import { ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Inject, Injector, Input, LOCALE_ID, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BpmnModelJsonHelper, ComponentConditionContent, ConditionEntity, ConditionType, ExpressionConditionContent } from '@edp-bif/common-api';
import { TypeConverter } from '@farris/ide-property-panel';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { LoadingService } from '@farris/ui-loading';
import { MessagerService } from '@farris/ui-messager';
import { BsModalService } from '@farris/ui-modal';
import { NotifyService } from '@farris/ui-notify';
import { ResponseToolbarClickEvent } from '@farris/ui-response-toolbar';
import { GSPMetadataRTService, Metadata4RefDto, SelectMetadataRTComponent } from '@gsp-lcm/metadatart-selector';
import { ExpressionService, InjectedType, VarEntity } from '@gsp-svc/expression';
import { FrameworkService } from '@gsp-sys/rtf-common';
import { Observable, of } from 'rxjs';
import { AifLocalePipe, BIF_LANG_RESOURCES } from '../aif-ui-common/pipe/aif-ui-common-locale.pipe';
import { IConditionEntity4Dg } from './entity/IConditionEntity4Dg';
import { StartConditionService } from './start-condition.service';
import { DataEntityService } from '@gsp-svc/data-entity-adapter';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { AbstractDatagridComponent } from './abstract-datagrid-component';
import { LANG_RESOURCES } from './i18n/lang.resource';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';


@Component({
  selector: 'lib-start-condition',
  templateUrl: './start-condition.component.html',
  styleUrls: ['./start-condition.component.css'],
  providers: [
    { provide: BIF_LANG_RESOURCES, useValue: LANG_RESOURCES },
    AifLocalePipe,
    StartConditionService,
  ]
})
export class StartConditionComponent extends AbstractDatagridComponent implements OnInit {
  readonly groupIcon = '<i class="f-icon f-icon-lookup"></i>';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(data: string) {
    data = data ? data : '[]';
    const conditionEntities: ConditionEntity[] = data ? [] : BpmnModelJsonHelper.FromJson(data, ConditionEntity);
    this.designedConditionEntities = conditionEntities.map((item) => {
      const entity: IConditionEntity4Dg = {
        id: item.id,
        isEnabled: item.isEnabled,
        name: item.name,
        type: item.type,
        remarks: item.remarks,
        component: {},
        expression: {},
      };

      if (entity.type == ConditionType.COMPONENT) {
        const compCondCont = new ComponentConditionContent();
        compCondCont.LoadFromJson(item.content);

        entity.component.compId = compCondCont.componentId;
        entity.component.compMetadataId = compCondCont.componentMetadataId;
        entity.component.compName = compCondCont.name;

        entity.displayedContent = entity.component.compName;
      } else if (entity.type == ConditionType.EXPRESSION) {
        const exprContent = new ExpressionConditionContent();
        exprContent.LoadFromJson(item.content);

        entity.expression.exprContent = exprContent.expressionContent;
        entity.displayedContent = entity.expression.exprContent;
      } else {

      }
      return entity;
    });
  }

  @Input() editorParams: {
    bizTypeId?: string;
    voId?: string;
  } = {};

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: '启动条件',
    width: 900,
    height: 400,
    showButtons: true,
    showHeader: false
  };

  @ViewChild("dg")
  dg: DatagridComponent;
  dgIdField: string = "id";
  dgColumns: DataColumn[];
  get dgData(): IConditionEntity4Dg[] {
    return this.designedConditionEntities;
  }
  set dgData(arr: IConditionEntity4Dg[]) {
    this.designedConditionEntities = arr;
  }
  get dgTotal(): number {
    return this.dgData.length || 0;
  }
  designedConditionEntities: Array<IConditionEntity4Dg> = new Array();

  @ViewChild("dgIsEnabledStateCell")
  dgIsEnabledStateCell: TemplateRef<any>;
  @ViewChild("dgOpCell")
  dgOpCell: TemplateRef<any>;

  editingRowId: string = null;
  canEdit: any = true;

  constructor(
    public startConditionService: StartConditionService,
    private designerState: ProcessDesignerUIState,
    public metadata: GSPMetadataRTService,
    public expr: ExpressionService,
    public des: DataEntityService,
    public messager: MessagerService,
    public notify: NotifyService,
    public modal: BsModalService,
    public framework: FrameworkService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public loading: LoadingService,
    @Inject(LOCALE_ID) localeId: string,
    public localePipe: AifLocalePipe,
    public cfr: ComponentFactoryResolver,
    public cdf: ChangeDetectorRef,
    public inj: Injector,
  ) {
    super(messager, notify, metadata, modal, localePipe, inj, cfr, cdf)
  }

  ngOnInit() {
    this.configDgColumns();
  }

  clickOk() {
    if (this.dg.isEditing() || this.editingRowId != null) {
      return;
    }
    const conditionEntities = this.designedConditionEntities.map((entity) => {
      const item: ConditionEntity = new ConditionEntity();
      item.id = entity.id;
      item.isEnabled = entity.isEnabled;
      item.name = entity.name;
      item.type = entity.type;
      item.remarks = entity.remarks;

      if (entity.type == ConditionType.COMPONENT) {
        const compCondCont = new ComponentConditionContent();
        compCondCont.name = entity.component.compName;
        compCondCont.componentId = entity.component.compId;
        compCondCont.componentMetadataId = entity.component.compMetadataId;

        item.content = compCondCont.ConvertToJson();
      } else if (entity.type == ConditionType.EXPRESSION) {
        const exprContent = new ExpressionConditionContent();
        exprContent.expressionContent = entity.expression.exprContent;

        item.content = exprContent.ConvertToJson();
      } else {

      }

      return item;
    });

    const val = BpmnModelJsonHelper.ToJson(conditionEntities);
    const obj = { value: val, parameters: null };
    this.submitModal.emit(obj);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  load(): void {
    throw new Error('Method not implemented.');
  }

  toolbarClickHandler(args: ResponseToolbarClickEvent) {
    switch (args.id) {
      case 'btn-add':
        this.add();
        break;
      case 'btn-remove':
        this.remove(null);
        break;
    }
  }

  add() {
    if (this.dg.isEditing() == false || this.dg.isEditing() == null) {
      const newItem = this.startConditionService.createConditionEntity();
      const newEntity: IConditionEntity4Dg = {
        id: newItem.id,
        name: newItem.name,
        type: newItem.type,
        isEnabled: newItem.isEnabled,
        remarks: newItem.remarks,
        component: {},
        expression: {},
      };

      this.dgData = [...this.dgData, newEntity];
      this.cdf.detectChanges();
      setTimeout(() => {
        this.dg.editRow(newItem.id);
        this.editingRowId = newItem.id;
      }, 0);
    } else {
      this.notify.warning(this.localePipe.instant("pleaseEndCurrentRowEditing"));
    }
  }

  /**
   * 行删除
   * @param ctx 
   */
  remove(evt: Event, ctx?: { rowIndex: number, rowData: { id;[key: string]: any } }) {
    const ids: string[] = [];
    if (ctx == null) {
      // 批量删除
      this.dg.checkeds.forEach(it => {
        ids.push(it.id);
      });
    } else {
      // 行内删除
      ids.push(ctx.rowData.id);
    }
    if (ids.length == 0) {
      this.notify.warning(this.localePipe.instant("pleaseSelectOneItemAtLeast"));
      if (evt != null) {
        evt.stopPropagation();
      }
      return false;
    }
    for (let id of ids) {
      this.dg.deleteRow(id);
    }
    this.dgData = this.dg.data;
    if (this.editingRowId != null) {
      if (ids.includes(this.editingRowId)) {
        this.editingRowId = null;
      } else {
        this.dg.editRow(this.editingRowId);
      }
    }
    this.cdf.detectChanges();
    if (evt != null) {
      evt.stopPropagation();
    }
    return false;
  }

  selectContent(e: { instance, form, formControl, $event }) {
    switch (e.form.value.type) {
      case ConditionType.COMPONENT:
        this.selectCommonComp(e);
        break;
      case ConditionType.EXPRESSION:
        this.showExpression(e);
        break;
      // case ConditionType.FULL_EXPRESSION:
      //   this.showExpression(e);
      //   break;
      // case ConditionType.INCREMENTAL_EXPRESSION:
      //   this.showExpression(e);
      //   break;
      case ConditionType.VOACTION:
        this.selectVOAction(e);
        break;
    }
  }

  public selectCommonComp(e: { instance, form, formControl, $event }): void {
    const compFactory = this.cfr.resolveComponentFactory(SelectMetadataRTComponent);
    const compRef = compFactory.create(this.inj);
    compRef.instance.typeList = "CommonComponent";
    // compRef.instance.boId = `${this.processContent.upBillBoId},${this.processContent.downBillBoId}`;
    compRef.instance.selectedMetadata.subscribe(
      (metadata4RefDto: Metadata4RefDto) => {
        const content = new ComponentConditionContent();

        const metadata = metadata4RefDto.metadata;
        const entity: IConditionEntity4Dg = e.form.bindingData;
        entity.component.compName = metadata.name;
        entity.component.compMetadataId = metadata.id;
        const metadataContent = JSON.parse(metadata.content);
        entity.component.compId = metadataContent.id || metadataContent.Id || metadataContent.ID || metadata.id;
        entity.displayedContent = entity.component.compName;

        e.formControl.setValue(entity.displayedContent);
        e.instance.cd.detectChanges();
      }
    );
    const modalConfig = {
      title: this.localePipe.instant("commonComponentMetadataSelector"),
      width: 930,
      height: 573,
      showButtons: false
    };
    const dialog = this.modal.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe($event => dialog.close());
  }

  public selectVOAction(e: { instance, form, formControl, $event }): void {

  }

  public showExpression(e: { instance, form, formControl, $event }): void {
    // this.expr.clearContext();
    const context = new Array<VarEntity>();
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }

    this.expr.addExpressionText(e.formControl.value);
    this.configExpressionExpendFuncs();

    let schema$: Observable<any> = this.des.getSchemaById(this.editorParams.voId);
    schema$.subscribe(
      (schema) => {
        this.expr.addNewSchema(schema.name, schema);
        this.expr.addInjectedEntity(schema.entityTypes[0].code, schema.name, schema.entityTypes[0].code, InjectedType.EntityType);

        this.expr.buildExpression(!this.canEdit).then(
          expressioninfo => {
            const content: ExpressionConditionContent = new ExpressionConditionContent();

            let temp: any = expressioninfo;
            const entity: IConditionEntity4Dg = e.form.bindingData;
            entity.expression.exprContent = temp;
            entity.displayedContent = entity.expression.exprContent;

            e.formControl.setValue(entity.displayedContent);
            e.instance.cd.detectChanges();
            //点击确定后，去除表达式里面的新增的上下文变量
            if(context.length > 0) {
              this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
            }
          }
        );
      }
    );
  }

  clearContent(e: { instance, form, formControl, $event }) {
    const entity: IConditionEntity4Dg = e.form.bindingData;
    entity.displayedContent = null;

    //构件
    entity.component.compName = null;
    entity.component.compMetadataId = null;
    entity.component.compId = null;

    //表达式
    entity.expression.exprContent = null;

    //VO动作

    e.formControl.setValue(null);
    e.instance.cd.detectChanges();
  }

  configDgColumns() {
    this.dgColumns = [
      // { field: 'id', title: this.localePipeService.instant("id"), width: 160 },
      {
        field: 'isEnabled', title: this.localePipe.instant("isEnabled"), width: 100, template: this.dgIsEnabledStateCell,
      },
      {
        field: 'type', title: this.localePipe.instant("type"), width: 120,
        editor: {
          type: EditorTypes.SELECT,
          options: {
            idField: "value",
            valueField: 'value',
            textField: 'text',
            data: [
              // { value: ConditionType.VOACTION, text: this.localePipeService.instant("billAction") },
              // { value: ConditionType.EXPRESSION, text: this.localePipe.instant("expression") },
              { value: ConditionType.COMPONENT, text: this.localePipe.instant("commonComponent") },
              // { value: ConditionType.FULL_EXPRESSION, text: this.localePipe.instant("fullExpression") },
              // { value: ConditionType.INCREMENTAL_EXPRESSION, text: this.localePipe.instant("incrementalExpression") },
            ]
          },
          validators: [
            { type: 'required', messager: this.localePipe.instant("typeMustNotBeNull") },
          ]
        },
        validators: [
          { type: 'required' },
        ],
        formatter: (value: ConditionType, rowData: any, rowIndex: any) => {
          switch (value) {
            case ConditionType.COMPONENT:
              return this.localePipe.instant("commonComponent");
            case ConditionType.EXPRESSION:
              return this.localePipe.instant("expression");
            // case ConditionType.FULL_EXPRESSION:
            //   return this.localePipe.instant("fullExpression");
            // case ConditionType.INCREMENTAL_EXPRESSION:
            //   return this.localePipe.instant("incrementalExpression");
            case ConditionType.VOACTION:
              return this.localePipe.instant("billAction");
            default:
              return "Unknown";
          }
        }
      },
      {
        field: "displayedContent", title: this.localePipe.instant("content"), width: 200,
        editor: {
          type: EditorTypes.INPUTGROUP,
          options: {
            groupText: this.groupIcon,
            editable: false,
            clickHandle: (e: { instance, form, formControl, $event }) => {
              this.selectContent(e);
            },
            clear: (e: { instance, form, formControl, $event }) => {
              this.clearContent(e);
            },
          },
          validators: [
            { type: 'required', messager: this.localePipe.instant("contentMustNotBeNull") }
          ]
        },
        validators: [
          { type: 'required' },
        ],
      },
      {
        field: 'remarks', title: this.localePipe.instant("description"), width: 200,
        editor: {
          type: EditorTypes.TEXTAREA, options: {},
        }
      },
      { field: null, title: this.localePipe.instant("operation"), width: 250, template: this.dgOpCell, halign: 'center', align: 'center' },
    ];
  }

  beforeEdit = (...args) => {
    // console.log('Before Edit', args);
    return of(true);
  }

  beginEdit(param: { rowIndex: number, rowData: any, column: any, gridInstance: DatagridComponent }) {
    // console.log('Begin Edit', param);
    this.editingRowId = param.rowData.id;
    const editors = param.gridInstance.getEditors();
    const select = editors[0];
    select.instance.formControl.valueChanges.subscribe((val) => {
      if (select.instance.dr.form.bindingData.type != val) {
        select.instance.group.bindingData.displayedContent = null;
        select.instance.group.controls.displayedContent.setValue(null);

        select.instance.group.bindingData.remarks = null;
        select.instance.group.controls.remarks.setValue(null);
        select.instance.dr.cd.detectChanges();
      }
    });
  }

  afterEdit = (rowIndex, rowData: IConditionEntity4Dg, ...args) => {
    if (rowData.component && rowData.component.compMetadataId) {
      return of(true);
    } else if (rowData.expression && rowData.expression.exprContent) {
      return of(true);
    } else {
      this.notify.warning(this.localePipe.instant("eventRouterConditionsContentCantBeEmpty"));
      return of(false);
    }
  }

  endEdit(...args) {
    // console.log('End Edit', args);
    this.editingRowId = null;
  }

  cancelEdited(...args) {
    // console.log('取消编辑', args);
    this.editingRowId = null;
  }

  public configExpressionExpendFuncs() {
    // let changeDetails: VarEntity =
    // {
    //   key: "changeDetails",
    //   name: "业务实体变更集列表",
    //   description: "业务实体变更集列表"
    // }
    // this.expr.addContext(changeDetails);
  }
}

export class StartConditionConverter implements TypeConverter {

  constructor() { }

  convertTo(data: any): string {
    if (data && data.StartCondition) {
      return '（已设置）';
    }
    return '（未设置）';
  }
}